import { render } from "./AllInOneAcceleratorsView.vue?vue&type=template&id=3b3837cf"
import script from "./AllInOneAcceleratorsView.vue?vue&type=script&lang=js"
export * from "./AllInOneAcceleratorsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__